import DataTable from 'components/Core/DataTable';
import Notify from 'lib/Utils/Alert';
import React, {  useMemo, useRef, useState } from 'react';
import ReactNotificationAlert from 'react-notification-alert';
import Select from 'react-select';
import { Button, Col, Input, Label, Row,Collapse } from 'reactstrap';
import $ from 'jquery';
import PurchaseOrderProcessing from 'lib/Core/Backend/Controllers/PurchaseOrderProcessing';
import { FormGroup, SwipeableDrawer } from '@mui/material';
import Papa from 'papaparse'
import PurchaseOrderDetail from './PurchaseOrderDetail'
import useCatalogs from 'hooks/useCatalogs';
import Spinner from 'react-bootstrap/Spinner';
import CryptoJS from 'crypto-js';
const dollar = Intl.NumberFormat('en-US', {
	style: "currency",
	currency: "USD",
});

const badges = {
	'1': `<span style="width: 100px" class="badge badge-pill text-white bg-wisteria">open</span>`,
	'2': `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`,
	'3': `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`,
	'4':  `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`,
	'5': `<span style="width: 100px" class="badge badge-pill text-white bg-warning">On hold</span>`,
  '6': `<span style="width: 100px" class="badge badge-pill text-white bg-info">API Low Funds</span>`,
  '7': `<span style="width: 100px" class="badge badge-pill text-white bg-info">Non API Low Funds</span>`,
  '8': `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">Incomplete</span>`,
  '11': `<span style="width: 100px" class="badge badge-pill text-white bg-warning">API Issue</span>`,
  '12': `<span style="width: 100px" class="badge badge-pill text-white bg-warning">CSV Mismatched</span>`,
}

const optionBadges = {
	'1': {
			label: `open`,
			value: 'open'
		},

	'2': {
			label: `in progress`,
			value: 'in progress'
		},
	'3': {
			label: `canceled`,
			value: 'canceled'
		},
	'4':  {
			label: `completed`,
			value: 'completed'
		},
	'5': {
			label: `On Hold`,
			value: 'On Hold'
		},
  '6': {
    label: `API Low Funds`,
    value: 'API Low Funds'
  },
  '7': {
    label: `Non API Low Funds`,
    value: 'Non API Low Funds'
  },
}

const PurchaseOrdersBySupplier = (props) => {
  const {currencies} = useCatalogs();
  const {token, suppliers, brands} = props;

  const PoProcessingCtl = useMemo(() => new PurchaseOrderProcessing(token), [token]);

  const alert = useRef();
  const table = useRef();
  const supplierSelect = useRef();
  const startDateInput = useRef();
  const endDateInput = useRef();

  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [supplier, setsupplier] = useState();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [totalOrder, setTotalOrder] = useState(0);
  const toggleDrawer = () => setOpenDrawer(!openDrawer);
  const [orderDetail, setOrderDetail] = useState([]);
  const [orderNumber,setOrderNumber] = useState("");
  const [cardNumber,setCardNumber] = useState("");
  const [toggleNumber,setToggleNumber] = useState(false);
  const [toggleCard,setToggleCard] = useState(false);
  const [orderHistory,setOrderHistory] = useState(false);
  const [supplierHistory,setSupplierHistory] = useState(false);
  const [loader,setLoader] = useState(false)
    const [startDateTwo,setStartDateTwo] = useState('');
    const [endDateTwo,setEndDateTwo] = useState('')
  const OrdersHistory = useRef();
  const CardHistory = useRef();
 const secretKey = process.env.REACT_APP_SECURE_SALT_KEY;
 const passkey = process.env.REACT_APP_PASSWORD_KEY
  const startInput = useRef();
  const endInput = useRef();
  

  const header = [
		{title: 'Date', data: 'createdAt', sortable: true, searchable: true, render: $.fn.dataTable.render.text(), renderForSelect: data => ({label: data, value: data})},
		{title: 'Name', data: 'name', sortable: true, searchable: true, render: data => {
			if(data)
				return data;
			return 'Not available';
		}},
    {title: 'Currency', data: 'currency', sortable: true, searchable: true},
		{title: 'Total Gift Card', data: 'subtotal', sortable: true, searchable: false, render: data => dollar.format(data)},
		{title: 'Total Amount', data: 'totalAmount', sortable: true, searchable: false, render: data => dollar.format(data)},
		{title: 'Total Quantity', data: 'totalQuantity', sortable: true, searchable: false, render: $.fn.dataTable.render.text()},
		{title: 'Status', data: 'status', sortable: true, searchable: true, render: (data) => {
			if(data){
				return badges[data] ?? 'Error'
			}
		},
		renderForSelect: data => {
			if(data){
				return optionBadges[data] ?? {
					label: 'error',
					value: 'error'
				}
			}
		}
	}
	];

  const header1 = [
    {title:"Date",data:"date",sortable: true , searchable: true,renderForSelect: data => ({label: data, value: data})},
    {title:"Order Number",data:"orderNum",sortable: true,searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Customer",data:"Name",sortable: true,searchable: true, render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Brand",data:"brand",sortable: true,searchable: true, render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Gift card name",data:"productName",sortable: true, searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Gift card code",data:"cardNumber",sortable: true, searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Card Identifier",data:"cardIdentifier",sortable:true,searchable:true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Supplier",data:"supplier",sortable: true, searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Supplier Order Numer", data:"suplierNumber",sortable: true, searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"supplier Order Identifier",data:"supplierOrderIdentifier",sortable:true,searchable:true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Inventory Date", data:"inventoryDate",sortable: true, searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    {title:"Inventory order", data:"inventoryOrderNumber",sortable: true, searchable: true,render: data => {
      if (data){
        return data;
      }else return ''
        
      
    }},
    ]
  

  const numberSelect = [
    {value:"1",label:"Search by Order Number"},
    {value:"2",label:"Search by Gift Card Code"},
    
]

  const handleSupplierChange = (e) => {
    setsupplier(e)
  }

  const handleNumberChange = (selectOption) =>{
   const label = selectOption?.label
   if(label === "Search by Gift Card Code"){
    setToggleCard(true);
    setToggleNumber(false);
   }else if(label === "Search by Order Number"){
    setToggleNumber(true);
    setToggleCard(false);
   }else{
    setToggleNumber(false);
    setToggleCard(false);
   }

   if(selectOption === null){
    setToggleNumber(false);
    setToggleCard(false);
   }
  }

  const handleDate = (e) => {
    if( e.target.id === 'startDate'){
      setstartDate(e.target.value)
      setendDate(null)
      endDateInput.current.value = '';
      endDateInput.current.select();
    } else {
      if(!startDate){
        Notify(alert, 'danger', 'First Select a start date');
        endDateInput.current.value = '';
        startDateInput.current.focus();
        return;
      }
      setendDate(e.target.value)
    }
  }

  const searchHistory = (e) => {
    e.preventDefault();
    if(!supplier){
      Notify(alert, 'danger', 'Select a Supplier');
      supplierSelect.current.focus();
      return;
    }

    if(!startDate){
      Notify(alert, 'danger', 'Select a start date');
      startDateInput.current.focus();
      return;
    }

    if(!endDate){
      Notify(alert, 'danger', 'Select a end date');
      endDateInput.current.focus();
      return;
    }

    PoProcessingCtl.ordersBySupplier(supplier.value, startDate, endDate, data => {
      if(data.error || data.errorMessage || data.length === 0){
        Notify(alert, 'danger', 'No Orders available')

      } else {
        let purchaseOrders = data.map(order => {
          let currency = currencies.find(currency => currency.id === order.currencyId)
          return {
            ...order,
            status: `${order.status}`,
            currency: currency?.code ?? 'N.A'
          }
        })
        if(table.current)
          table.current.dataTable.clear().rows.add(purchaseOrders).draw();
      }
    });

  }

  const decryptCardNumber = (encryptedGiftCard) => {
    try {

        const parts = encryptedGiftCard.split(":");

        if (parts.length !== 2) {
            throw new Error("Invalid encrypted data format.");
        }

        const ivBase64 = parts[0];
        const encryptedDataBase64 = parts[1];

        const iv = CryptoJS.enc.Base64.parse(ivBase64);

        const passKeyBase64 = process.env.REACT_APP_PUBLIC_KEY;
        const aesKey = CryptoJS.enc.Base64.parse(passKeyBase64);

        const decrypted = CryptoJS.AES.decrypt(encryptedDataBase64, aesKey, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
        });

        const decryptedCardNumber = decrypted.toString(CryptoJS.enc.Utf8);

        return decryptedCardNumber;
    } catch (error) {
        console.error("Error decrypting gift card number:", error);
        return null;
    }
};


  const searchorder =  async (e) =>{
    setLoader(true)
    if(toggleCard){
      const cleanCardNumber = cardNumber.replace(/\s+/g, '');

      if (cleanCardNumber === "") {
        Notify(alert, "warning", "Card Number cannot be empty or contain only spaces");
        setLoader(false)
        return;
      }
      if(!startDateTwo || !endDateTwo){
        Notify(alert,"danger"," StartDate & EndDate can not be empty")
        setLoader(false)
        return;
      }
     
      PoProcessingCtl.orderbyCardNumber(cleanCardNumber,startDateTwo,endDateTwo,(data)=>{
    
    if(data.errorCode || data.error){
      if(data?.error.includes("Server error response code: 500")){
        Notify(alert,"danger","Internal Server Error");
      }else{
        Notify(alert, 'danger', data.errorMessage ?? data?.error)
      }
      setTimeout(() => {
        setLoader(false)
      }, 500);
    }else{
     Notify(alert,'success',"Giftcard Information Has Been Found");
     const getDataByCard =  {
      date:data.date,
      Name:data.customer,
      brand:data.brandName,
      orderNum:data.orderNumber,
      supplier:data.supplier,
      suplierNumber:data.supplierOrderNumber,
      productName:data.productName,
      cardNumber:decryptCardNumber(data.cardNumber,data.publicIv),
      cardIdentifier:data.cardIdentifier,
      supplierOrderIdentifier:data.supplierOrderIdentifier,
      inventoryDate:data.inventoryDate,
      inventoryOrderNumber:data.inventoryOrderNumber

 };
 setTimeout(() => {
  setLoader(false)
}, 500);

     if (OrdersHistory.current ){
      OrdersHistory.current.dataTable.clear().row.add(getDataByCard).draw();
      }  
      // if(toggleNumber && orderHistory.current){
      //   OrdersHistory.current.datatable.clear()
      // }

    }
      })
     }else{
      if(orderNumber.trim() === ""){
        Notify(alert,"warning","Order Number can not be Empty")
        setLoader(false)
       return;
      }
      PoProcessingCtl.orderbyOrderNumber(orderNumber,(data)=> {
        if(data.errorCode || data.error){
         if(data?.error.includes("Server error response code: 500")){
            Notify(alert,"danger","Internal Server Error");
          }else{
            Notify(alert, 'danger', data.errorMessage ?? data?.error)
          }
          
          setTimeout(() => {
            setLoader(false)
          }, 500);
        }else{
          Notify(alert,'success',"Giftcard Information Has Been Found");
          const getApiData = data.map((order)=>({
            date:order.date,
            Name:order.customer,
            brand:order.brandName,
            orderNum:order.orderNumber,
            supplier:order.supplier,
            suplierNumber:order.supplierOrderNumber,
            productName:order.productName,
            cardNumber:decryptCardNumber(order.cardNumber,order.publicIv),
            cardIdentifier:order.cardIdentifier,
            supplierOrderIdentifier:order.supplierOrderIdentifier,
            inventoryDate:order.inventoryDate,
            inventoryOrderNumber:order.inventoryOrderNumber

       }));
          
       setTimeout(() => {
        setLoader(false)
      }, 500);
            if (OrdersHistory.current) {
              OrdersHistory.current.dataTable.clear().rows.add(getApiData).draw();
              }
          }
       })
     }
    
     
  }

  const handleInputChange = (e) => {
    const formattedValue = e.target.value;
    setCardNumber(formattedValue);
  };

  const downloadCSV = () => {
    let purchaseOrders = table.current.dataTable.data().toArray().map(order => {
      let currency = order?.currency ?? 'USD'
      const currencyFormat = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency !== 'N.A' ? currency ?? 'USD' : 'USD'
      })
      return {
        Order: order.name ?? 'Not available',
        Amount: order.subtotal ? currencyFormat.format(order.subtotal) : 'Not available',
        Quantity: order.totalQuantity ?? 'Not available',
        Total: order.totalAmount ? currencyFormat.format(order.totalAmount) : 'Not available',
        Status: optionBadges[order.status]?.value ?? 'Not available'
      }
    })
    if(purchaseOrders.length === 0){
      Notify(alert, 'danger', 'There are no orders')
      return;
    }
    let csv = Papa.unparse(purchaseOrders);
    const element = document.createElement("a");
    const file = new Blob([csv], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = "Purchase orders.csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  const prepareDetails = (row) => {
    const total = row.data().totalAmount
    PoProcessingCtl.purchaseOrderDetail(row.data().id, data => {
      if (data.error || data.errorMessage || data.length === 0 ){
        Notify(alert, 'danger', 'No Orders available')
      } else {
        data.forEach(item => {
          item.supplier = `${item.supplierFee} / ${item.supplierDiscount}`
          item.productName = brands.filter(brand => brand.id === item.giftCardTypeId )[0].productName
        })
        setOrderDetail(data)
        setTotalOrder(total)
        toggleDrawer()
      }
    });
  }

  const handleDateTwo = (e) => {
  if (e.target.id === 'startDate') {
      setStartDateTwo(e.target.value)
        setEndDateTwo(null)
        endInput.current.value = '';
        endInput.current.select();
      } else {
        if (!startDateTwo) {
          Notify(alert, 'danger', 'First Select a start date');
          endInput.current.value = '';
          startInput.current.focus();
          return;
        }
        const startDate = new Date(startDateTwo);
        const endDate = new Date(e.target.value);

    
    const differenceInTime = endDate - startDate; // Difference in milliseconds
    const differenceInDays = differenceInTime / (1000 * 3600 * 24); // Convert to days

    if (differenceInDays > 31) {
      Notify(alert, 'danger', 'The difference between start date and end date cannot exceed 30 days');
      endInput.current.value = '';
      return;
    }
        setEndDateTwo(e.target.value)
      }

    }

  return (
    <>
      <ReactNotificationAlert ref={alert} />
      <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo" onClick={() =>setSupplierHistory(!supplierHistory)} style={{ cursor: "pointer" }}>
							<i className={supplierHistory ? "fas fa-chevron-up" : "fas fa-chevron-down"} />&nbsp;&nbsp;Look up by Supplier
				</h6>
        <Collapse isOpen ={supplierHistory}>
        <Row className='ml-3 mb-5'>
        <Col md={4} >
          <FormGroup>
            <Label for='supplierSelect'>Supplier</Label>
            <Select
              id='supplierSelect'
              ref={supplierSelect}
              options={suppliers}
              onChange={handleSupplierChange}
              isClearable={true}
              defaultValue='Select a supplier'
            />
          </FormGroup>
          
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for='startDate' >Start date</Label>
            <Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={startDateInput} onChange={handleDate}/>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for='endDate'>End date</Label>
            <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={endDateInput} onChange={handleDate} min={startDate ? startDate : ''}/>
          </FormGroup>
        </Col>
        <Col md='auto'>
          <Button className='btn btn-primaryTwo my-4' onClick={searchHistory}>Search</Button>
        </Col>
      </Row>
      <Row className='justify-content-center'>
        <Col md={11}>
        <div className='table-responsive'>
          <DataTable 
            ref={table}
            data={null}
            options={{
							saveState: false,
              dom: 'ipt',
							order: [[0, 'desc']]
						}}
						columns={header}
						enableSelectFilters={true}
            addCustomButtons={[{
              callback: prepareDetails,
              name: 'purchaserDetails',
              icon: "fas fa-info-circle",
              style: 'padding: 5px 10px; background: transparent; font-size: 1.2rem',
              props: 'data-toggle="tooltip" data-placement="top" title="See Order details"'
            }]}
          />
          </div>
        </Col>
      </Row>
      <Row className='justify-content-end mr-4'>
        <Col sm='auto'>
          <Button className='btn btn-primaryTwo' onClick={downloadCSV}>
            Download
          </Button>
        </Col>
      </Row>
      </Collapse>
      <h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-3 d-flex align-items-center" onClick={() =>setOrderHistory(!orderHistory)} style={{ cursor: "pointer" }}>
							<i className={orderHistory ? "fas fa-chevron-up" : "fas fa-chevron-down"} />&nbsp;&nbsp; Look up by Order Number or gift card code
				</h6>
     <Collapse isOpen={orderHistory}>
      <Row className='ml-3 mb-5'>
        <Col md={3} >
          <FormGroup>
            <Label for='orderSelect'>Order Search</Label>
            <Select
              id='orderSelect'
              options={numberSelect}
              onChange={handleNumberChange}
              isClearable={true}
              defaultValue='Select a supplier'
            />
          </FormGroup>
          
        </Col>
        <Col md={3}>
          {toggleCard ? 
           <FormGroup>
           <Label for='cardvalue' >Gift Card Code</Label>
           <Input type='text' id='cardvalue' value={cardNumber}  onChange={(e)=>handleInputChange(e)} placeholder='Enter Card Number'/>
         </FormGroup>: ""}
         {toggleNumber ?
       <FormGroup>
       <Label for='ordervalue' >Order Number</Label>
       <Input type='text' id='ordervalue' value={orderNumber} onChange={(e)=>setOrderNumber(e.target.value)} placeholder='Enter Order Number'/>
     </FormGroup> : ""}
     </Col>
       
        
   {
    toggleCard ? 
    <>
<Col xs="auto">
      {
        toggleCard ?
        <FormGroup>
        <Label for='startDate' >Start date</Label>
        <Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}'
         innerRef={startInput} 
         onChange={handleDateTwo}
         />
      </FormGroup>
      : ""
      }
    
       </Col>
       <Col xs="auto">
       {
        toggleCard ? 
     <FormGroup>
        <Label for='endDate'>End date</Label>
        <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' 
        innerRef={endInput}
         onChange={handleDateTwo} 
         min={startDateTwo ? startDateTwo : ''}
         />
        </FormGroup>
        : ""
       }
       
       </Col>
       </>
       :
       ""
   }
      
  
        <Col md='auto'>
        {
          toggleNumber ||  toggleCard ?
          <Button className='btn btn-primaryTwo my-4' onClick={searchorder} disabled={loader}>Search{
            loader && 
            <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          style={{marginLeft:"5px"}}
                         />
          }</Button>
          : 
          ""
        }
          
        </Col>
      </Row>
     
      
     
        <Row className='justify-content-center' style={{marginTop:"15px"}}>
          <Col md={11}>
          <div className='table-responsive'>
          <DataTable
        ref={OrdersHistory}
        data={null}
        options={{
          saveState: false,
          dom: 'ipt',
          order: [[0, 'desc']]
        }}
        columns={header1}
        enableSelectFilters={true}
      />
      </div>
          </Col>
        </Row>
      </Collapse>
      
     
      <SwipeableDrawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
      >
        <div style={{ width: "60vw" }}>
          <PurchaseOrderDetail data={orderDetail} total={totalOrder }/>
        </div>
      </SwipeableDrawer>
    </>
  );
}
 
export default PurchaseOrdersBySupplier;
